
import React from 'react';
import { Modal } from 'antd';

export const IdleTimeOutModal = ({showModal, handleClose, handleLogout, remainingTime}) => {

    return (
        <Modal
            title="Inactivity Timeout"
            visible={showModal}
            onOk={handleLogout}
            onCancel={handleClose}
            okText="Logout"
            cancelText="Stay"
        >
            <p>Your session has expired due to inactivity. You are now being logged out...</p>
        </Modal>
    )
}

// example timeout modal
/*
    return (
        <Modal show={showModal} onHide={handleClose}>
            <Modal.Header closeButton>
            <Modal.Title>You Have Been Idle!</Modal.Title>
            </Modal.Header>
            <Modal.Body>You Will Get Timed Out. You want to stay?</Modal.Body>
            <Modal.Footer>
            <Button variant="danger" onClick={handleLogout}>
                Logout
            </Button>
            <Button variant="primary" onClick={handleClose}>
                Stay
            </Button>
            </Modal.Footer>
        </Modal>
    )
*/



// WEBPACK FOOTER //
// ./src/utils/IdleModal.js